import { render, staticRenderFns } from "./TenantPoint.vue?vue&type=template&id=69d72414&scoped=true"
import script from "./TenantPoint.vue?vue&type=script&lang=js"
export * from "./TenantPoint.vue?vue&type=script&lang=js"
import style0 from "./TenantPoint.vue?vue&type=style&index=0&id=69d72414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d72414",
  null
  
)

export default component.exports